import React, { useState, useEffect, useRef } from 'react';
import './index.scss';
import _ from 'lodash';
import { Helmet } from 'react-helmet';
import { getFaqs } from '../../services/Api/CMS/CMSService';
import {
  HELP_DESC,
  HELP_TITLE,
  HELP_DESC_ES,
  HELP_TITLE_ES
} from '../../constants/defaults';
import Picture from '../common/Picture';
import FaqAccordian from './FaqAccordian';
import FaqForm from './FaqForm';
import { withTranslation } from 'react-i18next';
import SkipTo from '../common/Tag/SkipTo';
const Faq = ({ faqs, t, i18n }) => {
  const [faqResponse, setFaqResponse] = useState(faqs);
  const [showLoader, setLoader] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [displayValue, setDisplayValue] = useState('');
  const [filtereadArray, setFilteredArray] = useState([]);
  const [showSearchResult, setSearchResult] = useState(false);
  const QandAArray = [];
  const isFirstRun = useRef(true);
  let isEs = _.isEqual(i18n.language, 'es');
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    (async () => {
      setLoader(true);
      const faqResponse = await getFaqs(i18n.language);
      if (faqResponse) {
        setFaqResponse(faqResponse.faqs);
        setLoader(false);
      }
    })();
  }, [i18n.language]);

  const handlekeyPress = event => {
    if (event.key === 'Enter') {
      _.isEmpty(inputValue.trim()) ? clearSearchResult() : searchFaq(event);
    }
  };

  const handleInputChange = event => {
    event.preventDefault();
    setInputValue(event.target.value);
  };

  const searchFaq = event => {
    event.preventDefault();
    const searchRegex = inputValue.trim().toLowerCase();
    if (_.isEmpty(QandAArray)) {
      faqResponse.forEach(item => {
        QandAArray.push(...item.QandA);
      });
    }
    const result = QandAArray.filter(
      item =>
        item.Question.toLowerCase().includes(searchRegex) ||
        item.Answer.toLowerCase().includes(searchRegex)
    );
    setDisplayValue(inputValue.trim());
    setFilteredArray(result);
    setSearchResult(true);
    window.scrollTo(0, 30);
  };

  const clearSearchResult = () => {
    setInputValue('');
    setDisplayValue('');
    setSearchResult(false);
  };

  return (
    <div>
      <div className="faqMainContainer">
        <div className="topShadow"></div>
        <Helmet>
          <title>{isEs ? HELP_TITLE_ES : HELP_TITLE}</title>
          <meta name="description" content={isEs ? HELP_DESC_ES : HELP_DESC} />
          <link
            rel="alternate"
            href="https://www.singlecare.com/help"
            hrefLang="en-us"
          />
          <link
            rel="alternate"
            href="https://www.singlecare.com/es/ayuda"
            hrefLang="es-us"
          />
          <link
            rel="canonical"
            href={
              isEs
                ? `https://www.singlecare.com/es/ayuda`
                : `https://www.singlecare.com/help`
            }
          />
        </Helmet>
        {showLoader ? (
          <div className="loaderWrap">
            <img
              className="imgLoader"
              src="/content/images/loader/loading.gif"
              alt="loader"
            />
          </div>
        ) : (
          <div>
            <div className="helpSearch">
              <div className="helpSearchContainer">
                <SkipTo>
                  <h1 id="helpSearchSection">{t('How can we help?')}</h1>
                </SkipTo>
                <div
                  className="searchSectiom"
                  role="search"
                  aria-labelledby="helpSearchSection"
                >
                  <div className="searchInput">
                    <div className="InputWidth">
                      <input
                        onKeyPress={handlekeyPress}
                        onChange={handleInputChange}
                        placeholder={t('Search our FAQs')}
                        type="text"
                        value={inputValue}
                        aria-label={t('Search our FAQs')}
                        aria-required="true"
                        className="whiteFocus"
                      />
                      {!_.isEmpty(inputValue.trim()) && (
                        <button
                          className="crossbutton"
                          onClick={clearSearchResult}
                        >
                          <Picture
                            imagePath="icons/cross"
                            imgClass="close"
                            alt={t('Remove search')}
                          />
                        </button>
                      )}
                    </div>
                  </div>
                  <button
                    onClick={searchFaq}
                    className={`searchBtn whiteFocus ${
                      _.isEmpty(inputValue.trim()) && 'pointerNone'
                    }`}
                  >
                    <Picture
                      imagePath="icons/SearchIcon"
                      imgClass="SearchIcon"
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
            <div className="faqContent">
              <div className="topicContent">
                {!showSearchResult &&
                  _.map(faqResponse, (item, i) => {
                    return (
                      <div key={i}>
                        <h2 id={`${item.CategoryId}`}>{item.CategoryText}</h2>
                        <FaqAccordian faq={item.QandA} />
                      </div>
                    );
                  })}
                {showSearchResult && (
                  <div
                    className={`searchResult ${
                      filtereadArray.length === 1 && 'oneResult'
                    }`}
                  >
                    <h2>{t('Search results')}</h2>
                    <p className="SearchResultsText">{`"${displayValue}" - ${
                      filtereadArray.length
                    } ${t('result')}${
                      filtereadArray.length !== 1 ? 's' : ''
                    }`}</p>
                    {_.isEmpty(filtereadArray) ? (
                      <div className="resultNotFound">
                        <h4>{t('No results found.')}</h4>
                        <p onClick={clearSearchResult}>
                          <span>{t('Go back to all topics')}</span>
                        </p>
                      </div>
                    ) : (
                      <FaqAccordian faq={filtereadArray} />
                    )}
                  </div>
                )}
                {!showSearchResult && (
                  <div className="backToTop textCenter">
                    <a href="#" rel="noopener noreferrer">
                      {t('Back to the top')}
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="faqMainContainer margin0">
        <FaqForm />
      </div>
    </div>
  );
};

export default withTranslation()(Faq);
